import posthog from 'posthog-js';

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_TOKEN || '', {
  api_host: '/ingest',
  ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: 'history_change',
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') posthog.debug(); // debug mode in development
  },
});
